<template>
  <el-popover
    placement="bottom-start"
    width="200"
    trigger="click"
    transition="el-zoom-in-top"
    class="ips-org-tree"
    popper-class="ips-org-tree__popper"
    v-model="visible"
    @hide="handleHide"
  >
    <div class="ips-org-tree__tree-container" ref="tree-container">
      <scroll>
        <el-tree
          ref="tree"
          :data="data"
          :show-checkbox="showCheckBox"
          lazy
          node-key="id"
          :filter-node-method="filterNode"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :expand-on-click-node="expandOnClickNode"
          :props="defaultProps"
          :load="loadOrg"
          @node-click="handleNodeClick"
          @check-change="handleCheckChange"
        ></el-tree>
      </scroll>
    </div>
    <el-input
      v-if="!orgNode"
      slot="reference"
      v-model="name"
      :clearable="clearable"
      :readonly="readonly"
      class="ips-org-tree__input"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @input="handleInput"
      @click.native="handleClick"
    ></el-input>
    <el-input
      v-else
      slot="reference"
      v-model="orgNode.name"
      :readonly="readonly"
      :clearable="clearable"
      class="ips-org-tree__input"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @input="handleInput"
      @click.native="handleClick"
    ></el-input>
  </el-popover>
</template>
<script>
import {utils, Scroll} from "@/components";
import {mapState} from "vuex";

export default {
  name: "orgTree",
  components: {
    Scroll
  },
  props: {
    value: [Object, String],
    orgName: String,
    defaultExpandedKeys: Array,
    defaultCheckedKeys: Array,
    showCheckBox: Boolean,
    expandOnClickNode: {
      default: false
      , type: Boolean
    },
    placeholder: String,
    onlyLeafChecked: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    onlySelectId: {type: Boolean, default: false},
    onlyValue: [String, Number],
    id: [String, Number],
    width: {
      default: 200
    },
    /***'
     * 对应orgKindId: ogn,dpt,pos,psm
     * 和typeSign： 3，5,7,9
     *
     * */
    filterLevel: String,
    selectLevel: String,
    url: {type: String, default: 'common/allOrgTree'}
  },
  data() {
    return {
      visible: false,
      defaultProps: {
        isLeaf: data => !data.children,
        label: "name",
        disabled: "disabled"
      },
      data: [],
      name: ''
    };
  },
  watch: {
    orgName(value) {
      this.name = value
    }
  },
  computed: {
    ...mapState("app", ["currentUser"]),
    singleSelect() {
      return !this.showCheckBox;
    },
    multiSelect() {
      return this.showCheckBox;
    },
    filterArr: function () {
      let result = ["ogn", "dpt", "pos", "psm"];
      switch (this.filterLevel) {
        case "ogn":
          result = ["ogn"];
          break;
        case "dpt":
          result = ["ogn", "dpt"];
          break;
        case "pos":
          result = ["ogn", "dpt", "pos"];
          break;
        case "psm":
          result = ["ogn", "dpt", "pos", "psm"];
          break;
        case "pro":
          result = ["ogn", "dpt"];
          break;
      }
      return result;
    },
    orgNode() {
      return (Object.prototype.toString.call(this.value) === '[object Object]') ? Object.assign({}, this.value) : null;
    },
  },
  methods: {
    loadOrg({level, data}, resolve) {
      if (level === 0) {
        return this.$store
          .dispatch(this.url, this.currentUser.tenancyCode)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      } else {
        return this.$store
          .dispatch(this.url, data.id)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            if (this.filterLevel == "pro") {
              arr = arr.filter(o => o.typeSign != null && o.typeSign <= 9);
            }
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      }
    },
    handleHide() {
      this.visible = false;
    },
    handleClick() {
      // this.visible = !this.visible
    },
    handleInput() {
      this.visible = true;
      // 根据用户的输入过滤树节点
      // console.log(this.orgNode.name);
      //   this.$refs.tree.filter(this.orgNode.name);
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    handleChange() {
      if (utils.isEmpty(this.name)) {
        this.$emit("input", {});
        this.$emit("change", {});
      }
    },
    finish(node) {
      if (this.onlySelectId) {
        this.$emit("input", node.id);
        this.$emit("change", node.id);
        this.name = node.name
      } else {
        this.$emit("input", node);
        this.$emit("change", node);
      }
      this.visible = false;
    },
    handleNodeClick(node) {
      if (!this.showCheckBox) {
        if (this.onlyLeafChecked) {
          if (!node.children) {
            this.finish(node);
          }
        } else {
          this.finish(node)
        }
      }
    },
    handleCheckChange() {
      if (this.showCheckBox) {
        let nodes = this.$refs["tree"].getCheckedNodes(true);
        this.$emit("update:name", nodes.map(node => node.label).join());
        this.$emit("input", nodes);
        this.$emit("change", nodes);
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/dropTree.scss";
</style>
